import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const infisical = defineConnector({
  identifier: "infisical",
  name: "Infisical",
  tagLine: "Secrets management platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () =>
    "https://us\\.infisical\\.com/.*|https://eu\\.infisical\\.com/.*|https://app\\.infisical\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a machine identity token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Infisical](https://app.infisical.com/), create a **Machine Identity** and generate a Universal Auth access token. See the [API docs](https://infisical.com/docs/api-reference/overview/introduction) for details.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://us.infisical.com/api/v1/organizations",
  },
});
